import React from "react";
import { Button } from "react-bootstrap";
import  UiBtnLoader from "../common/UiBtnLoader"
import UiDotLoader from "../common/UiDotLoader"


export const UiButton = (props) => {
    return (
        <>
            <button className={props.className} onClick={props.onClick}>
                {
                    props.imageIcon &&
                    <div>
                        <img src={props.imageIcon} />
                    </div>
                }

                {
                    props.svgIcon &&   props.svgIcon
                }

                {props.title}
            </button>
        </>
    )
}


export const UiButtonPrimary = (props) => {
    return (
        <>
            <Button disabled={props.disabled}
                className={ props.size ? 'sb-btn sb-primary-btn--'+ props.size : 'sb-btn sb-primary-btn--48'} 
                onClick={props.onClick}>
                {props.btnName}
                
            </Button>
        </>

    );
};

export const UiButtonSecondary = (props) => {
    return (
        <>
            <Button
                className={ props.size ? 'sb-btn btn-secondary sb-secondary-btn--'+ props.size : 'sb-btn btn-secondary sb-secondary-btn--70'}
                onClick={props.onClick}>
                {props.btnName}
                {props.btnSubName && 
                    <span>{props.btnSubName}</span>
                }
            </Button>
        </>

    );
};

export const UiButtonIcon = (props) => {
    return (
        <>
            <Button
                className={ props.size ? 'sb-btn-icon sb-btn-icon--'+ props.size : 'sb-btn-icon sb-btn-icon--46'}
                onClick={props.onClick}>
                {props.icon}
                {props.btnName}
            </Button>
        </>

    );
};

export const UiButtonOutline= (props) => {
    return (
        <>
            <Button
                variant="outline-primary"
                className={ props.size ? 'sb-btn-outline sb-btn-outline--'+ props.size : 'sb-btn-outline sb-btn-outline--46'}
                disabled={props.isLoading}
                onClick={!props.isLoading ? props.onClick : null}>
                   {props.isLoading && <UiDotLoader/> } 
                   
                {props.btnName}
            </Button>
        </>

    );
};

